import React from 'react';
import PropTypes from 'prop-types';
import { GlowingEffect } from './border-effect/GlowingEffect';



const TechServiceCard = ({ image, name, index }) => {
  return (
    
    <div
    className="lg:p-8 p-5 lg:min-h-[186px] flex flex-col justify-center items-center text-center 
                 bg-[#242424]  
                 border border-transparent transition-all duration-300 rounded-lg"
      data-aos="fade-right"
      data-aos-delay={index * 100}
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >

      <GlowingEffect
          blur={0}
          borderWidth={2}
          spread={80}
          glow={true}
          disabled={false}
          proximity={64}
          inactiveZone={0.01}
        />
      <div className=" mb-4 flex items-center justify-center">
        <img src={image} alt={name} className="w-full h-full object-contain" />
      </div>
      <h3 className=" lg:text-lg text-[#9E9E9E] font-dmsans font-medium leading-snug text-body-sm hover:text-[#FFFFFF]" >
        {name}
      </h3>
    </div>
  );
};

TechServiceCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default TechServiceCard;
